<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../Mixins/global'
import DocumentShowAction from './DocumentShowAction.vue'
import ModalConfirmation from '../UI/Modal/ModalConfirmation.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import DocumentDownloadButton from './DocumentDownloadButton.vue'
import DocumentDropbox from './DocumentDropbox.vue'
import AddDocumentButtonAndModal from './AddDocumentButtonAndModal.vue'
import DocumentSignBlock from './DocumentSignBlock.vue'

export default {
  components: {
    AddDocumentButtonAndModal,
    DocumentDropbox,
    DocumentDownloadButton,
    ButtonAll,
    ModalConfirmation,
    DocumentShowAction,
    DocumentSignBlock,
  },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    context: { type: String, required: true },
    contextId: { type: Number, required: true },
    restrict: { type: String, required: false },
    uuid: { type: String, required: false },
    internalname: { type: String, required: false },
    readOnly: { type: Boolean, required: false },
    loadOnly: { type: Boolean, required: false },
    missingOnly: { type: Boolean, required: false },
    withoutMissing: { type: Boolean, required: false },
    addOnly: { type: Boolean, default: false },
    missingAndAcceptOnly: { type: Array, default: [] },
    showCancel: { type: Boolean, default: false },
    id: { type: String, default: 'button' },
  },

  data() {
    return {
      groupedByCategory: [],
      deleting: false,
      documentLoaded: false,
      collapse: null,
      sending: new Map(),
      currentDocumentForSign: null,
    }
  },

  computed: {
    isAllowedToAddOrGenerateDocument() {
      return (!this.readOnly || this.addOnly) && this.missingOnly === false && this.missingAndAcceptOnly.length === 0
    },
    isClient() {
      return (this.user === null || this.user.platforms.length === 0) && this.conf.connect_client
    },
  },

  methods: {
    getOrderedDocumentSignFilesStatuses(documentSignFilesStatuses) {
      // sort documentSigner.validator first, then by id ascending
      return documentSignFilesStatuses.slice().sort((a, b) => {
        if (a.documentSigner.validator && !b.documentSigner.validator) {
          return -1
        } else if (!a.documentSigner.validator && b.documentSigner.validator) {
          return 1
        } else {
          return a.id - b.id
        }
      })
    },
    getUrl() {
      let url = 'documents?contextId=' + this.contextId + '&context=AppBundle\\Entity\\' + this.context

      if (this.restrict) {
        url += '&restrict=' + this.restrict
      }
      if (this.uuid) {
        url = 'free/' + url + '&uniqid=' + this.uuid
      }
      if (this.internalname) {
        url += '&internalname=' + this.internalname
      }
      if (this.showCancel) {
        url += '&showCancel=1'
      }

      return url
    },
    groupedDocuments(documents) {
      const groupedDocuments = Object.values(
        documents.reduce((acc, document) => {
          const categoryName = document.document.documentType.documentCategory
            ? document.document.documentType.documentCategory.name
            : null
          acc[categoryName] = acc[categoryName] || {
            category: document.document.documentType.documentCategory,
            documents: [],
          }
          delete document.document.documentType.documentCategory
          acc[categoryName].documents.push(document)
          return acc
        }, {}),
      )

      return groupedDocuments
    },
    groupedMissings(missings) {
      const groupedMissings = Object.values(
        missings.reduce((acc, document) => {
          const categoryName = null
          acc[categoryName] = acc[categoryName] || {
            category: { transKey: 'document.missing', listOrder: 0 },
            missings: [],
          }
          delete document.documentType.documentCategory
          acc[categoryName].missings.push(document)
          return acc
        }, {}),
      )

      return groupedMissings
    },
    groupAndMerge(documents, missings) {
      const mergedArray = [...documents, ...missings]

      // Créer un objet pour regrouper les éléments par catégorie
      const groupedByCategory = Object.values(
        mergedArray.reduce((acc, item) => {
          const { category } = item
          const categoryName = category ? category.name : null

          acc[categoryName] = acc[categoryName] || { category, documents: [], missings: [], open: true }
          if (item.documents) {
            acc[categoryName].documents.push(...item.documents)
          } else if (item.missings) {
            acc[categoryName].missings.push(...item.missings)
          }

          return acc
        }, {}),
      ).sort((a, b) => {
        const listOrderA = a.category ? a.category.listOrder : null
        const listOrderB = b.category ? b.category.listOrder : null

        if (a.category === null && b.category !== null) {
          return 1 // Met a en dernier si a a une catégorie null
        } else if (a.category !== null && b.category === null) {
          return -1 // Met a en dernier si b a une catégorie null
        } else if (listOrderA !== null && listOrderB !== null) {
          return listOrderA - listOrderB // Trie par ordre de listOrder
        } else if (listOrderA === null && listOrderB !== null) {
          return 1 // Met a avant b si a n'a pas de listOrder et b en a un
        } else if (listOrderA !== null && listOrderB === null) {
          return -1 // Met a avant b si b n'a pas de listOrder et a en a un
        } else {
          return 0 // Maintient l'ordre si les deux ont null listOrder
        }
      })
      return groupedByCategory
    },
    getComment(comment) {
      return `<i class="fa fa-comment" data-toggle="tooltip" data-placement="right" title="${comment}"></i>`
    },
    getStatus(document) {
      let status = this.$t('document.status.undefined')
      let doc = document.document
      if (doc.documentSignFiles && doc.documentSignFiles.length > 0) {
        status = ''
        let signFileStatuses = doc.documentSignFiles[0].documentSignFileStatuses
        for (let i = 0; i < signFileStatuses.length; i++) {
          let signFileStatus = signFileStatuses[i]
          let doc_status = ''

          switch (signFileStatus.status) {
            case 'CREATED':
            case 'PENDING':
              doc_status = this.$root.$t(
                'document.status.waitingSignature' + (signFileStatus.documentSigner.validator ? '_validator' : ''),
              )
              break
            case 'SIGNED':
            case 'SIGNED_FULL':
              doc_status = this.$root.$t(
                'document.status.signed' + (signFileStatus.documentSigner.validator ? '_validator' : ''),
              )
              break
            case 'PROCESSING':
              doc_status = this.$root.$t(
                'document.status.inSigning' + (signFileStatus.documentSigner.validator ? '_validator' : ''),
              )
              break
            case 'CANCELLED':
              doc_status = this.$root.$t('document.status.cancel')
              break
            case 'ERROR':
              doc_status = this.$root.$t('document.status.error')
              break
            default:
              doc_status = this.$root.$t('document.status.undefined')
          }

          status += doc_status
          if (signFileStatus.signedAt) {
            let date = this.$root.$d(new Date(signFileStatus.signedAt), 'datetime_short')
            status += ' ' + this.$root.$t('document.status.date', { date: date })
          }
          if (signFileStatus.cancelledAt) {
            let date = this.$root.$d(new Date(signFileStatus.cancelledAt), 'datetime_short')
            status += ' ' + this.$root.$t('document.status.date', { date: date })
          }
          if (signFileStatus.documentSigner) {
            status +=
              ' ' +
              this.$root.$t('document.status.by', {
                par: signFileStatus.documentSigner.firstname + ' ' + signFileStatus.documentSigner.lastname,
              })
            if (signFileStatus.documentSigner.comment) {
              status += ` 🢒 "${signFileStatus.documentSigner.comment}"`
            }
          }
          status += '<br>'
        }
      } else if (doc.validatedAt) {
        let date = this.$root.$d(new Date(doc.validatedAt), 'date_short')
        status = this.$root.$t('document.status.VALIDATED', { date: date })
      } else {
        status = this.$root.$t('document.status.' + doc.status)
      }

      return status
    },
    getStatusSignColor(document) {
      if (document.document.documentSignFilesStatuses.length === 0) {
        return 'gray'
      }
      return document.document.documentSignFilesStatuses.every(({ documentSigner }) =>
        ['SIGNED', 'SIGNED_FULL'].includes(documentSigner.status),
      )
        ? 'success'
        : 'warning'
    },
    getDocumentSignerType(documentSigner) {
      return this.$t(`document.documentSigner.signType.${documentSigner.signType}`)
    },
    isAllowedToSign(doc) {
      return doc.document.documentTemplate?.signerParams.length > 0 && this.hasRole('ROLE_ADVANCE_DOCUMENT_SIGN')
    },
    hoverTool(event) {
      const element = $(event.target)
      if (!element.data('bs.tooltip')) {
        element.tooltip({
          html: true,
          sanitize: false,
          placement: 'right',
          container: 'body',
          boundary: 'viewport',
        })
        element.tooltip('show')
      }
    },
    async getDocuments() {
      this.documentLoaded = false
      const json = await this.getJSON(this.getUrl())
      this.groupedByCategory = this.groupAndMerge(
        this.groupedDocuments(json.documents),
        this.groupedMissings(json.missings),
      )
      this.$emit('document-loaded', json)
      this.documentLoaded = true
    },
    async deleteDocument(document) {
      if (!confirm(this.$t('document.confirmForDel', { fileName: document.document.documentType.name }))) {
        return
      }

      this.deleting = true

      try {
        await this.deleteJSON('documents/' + document.id)
        this.getDocuments()

        this.toast(this.$t('document.deletingOk', { fileName: document.document.documentType.name }))
        this.$emit('document-deleted', this.contextId)
      } catch (error) {
      } finally {
        this.deleting = false
      }
    },
    availableDocuments(categories) {
      if (this.missingAndAcceptOnly.length > 0) {
        return categories.documents.filter(
          (doc) => this.missingAndAcceptOnly.includes(doc.code) && doc.document.status === 'REFUSED',
        )
      }

      if (this.missingOnly) {
        return []
      }

      if (this.isClient) {
        return categories.documents.filter(
          (doc) => doc.code !== 'invoice' || doc.document.documentType.internalName !== 'invoice',
        )
      }

      return categories.documents
    },
    missingDocuments(categories) {
      if (this.withoutMissing) {
        return []
      }
      return categories.missings
    },
    isAllowedToDeleteDocument(document) {
      return this.hasRole('ROLE_DOCUMENT_DELETE')
    },
    isSignerAlreadySigned(documentSigner) {
      return ['SIGNED', 'SIGNED_FULL'].includes(documentSigner.status)
    },
    showDocumentSigner(document) {
      this.collapse = this.collapse === document.id ? null : document.id
    },
    prepareDocumentSign(doc) {
      if (doc.document.documentSignFilesStatuses.length === 0 && this.isAllowedToSign(doc)) {
        this.currentDocumentForSign = doc
        this.$refs.modalconfirmation.showModal()
        return
      }
      return this.showDocumentSigner(doc)
    },
    async addSign() {
      if (!this.currentDocumentForSign) {
        return
      }

      await this.getJSON(`document/${this.currentDocumentForSign.id}/addSign/`)
      this.$refs.modalconfirmation.closeModal()
      await this.getDocuments()
      this.currentDocumentForSign = null
    },
    sendSign(documentSigner) {
      window.open(`../sign/${documentSigner.id}?token=${documentSigner.token}`, '_blank')
    },
    async send(documentSigner, documentAssocId) {
      this.sending.set(documentSigner.id, true)
      await this.patchJSON(`documentsigns/${documentAssocId}/send`, {
        documentSignerId: documentSigner.id,
        token: documentSigner.token,
      })
      this.$root.jsonStatus = 'success'
      this.$root.jsonStatusText = this.$t('contract.document.sendSign.signTo', { name: `${documentSigner?.fullname}` })
      this.$root.jsonStatusObject = null

      this.sending.delete(documentSigner.id)
      $('#modal-waiting-text').modal({ backdrop: 'static', keyboard: false })
    },
    async onDocumentUploaded(document) {
      await this.getDocuments()
      this.$emit('document-uploaded', document)
    },
    async onDocumentGenerated() {
      await this.getDocuments()
    },
  },

  beforeMount() {
    this.getDocuments()
  },
}
</script>
<template>
  <div class="document-list" v-if="!loadOnly && documentLoaded">
    <div v-if="isAllowedToAddOrGenerateDocument" class="my-2">
      <AddDocumentButtonAndModal
        :id="id"
        :context="context"
        :context-id="contextId"
        @document-uploaded="onDocumentUploaded"
        @update:document="onDocumentGenerated"
      />
    </div>
    <table class="table table-striped table-hover fs-16">
      <thead>
        <tr>
          <th>{{ $t('document.table.labelDocument') }}</th>
          <th>{{ $t('document.table.labelStatus') }}</th>
          <th v-if="!readOnly">{{ $t('document.table.labelAction') }}</th>
        </tr>
      </thead>
      <tbody v-if="groupedByCategory.length > 0">
        <template v-for="(categories, index) in groupedByCategory">
          <tr
            v-if="
              (missingDocuments(categories).length > 0 || availableDocuments(categories).length > 0) &&
              conf.theme_dir !== 'solufinance'
            "
            class="document-category font-weight-bold"
            @click="categories.open = !categories.open"
            e2e-button="documentCategoryToggle"
            :e2e-row="'documentCategory-' + index"
          >
            <td e2e-data="documentCategoryName">
              {{
                categories.category
                  ? $te(categories.category.transKey)
                    ? $t(categories.category.transKey)
                    : categories.category.name
                  : $t('document.noCategory')
              }}
            </td>
            <td></td>
            <td class="text-center">
              <i :class="['fas', categories.open ? 'fa-caret-down' : 'fa-caret-right']"></i>
            </td>
          </tr>
          <tr
            v-if="categories.open"
            v-for="(missing, index) in missingDocuments(categories)"
            :e2e-row="'missingDocument-' + index"
          >
            <td e2e-data="missingDocumentTypeName">
              {{ missing.documentType.name + (missing.name ? ' ' + missing.name : '') }}
            </td>
            <td e2e-data="missingDocumentIsBlocking">
              {{ missing.isBlocking === true ? $t('document.status.blocking') : $t('document.status.missing') }}
            </td>
            <td v-if="!readOnly">
              <DocumentDropbox update="new" :document="missing" :uuid="uuid" @document-uploaded="onDocumentUploaded" />
            </td>
          </tr>
          <template v-if="categories.open" v-for="(doc, index) in availableDocuments(categories)">
            <tr :e2e-row="'availableDocument-' + index">
              <td>
                <DocumentDownloadButton :document="doc" :uuid="uuid" />
                <div
                  v-if="doc.document.comment != null"
                  class="ml-3"
                  v-html="getComment(doc.document.comment)"
                  e2e-data="availableDocumentComment"
                />
              </td>
              <td>
                <div class="d-flex">
                  <div
                    :class="'mr-3 my-tooltip status_check status_check_' + doc.document.statusCheck"
                    :data-original-title="doc.document.checkMessagesFormatted"
                    @mouseover="hoverTool"
                  ></div>
                  <span v-html="getStatus(doc)" e2e-data="availableDocumentStatus" />
                  <span v-if="doc.document.status == 'INCOMPLETE'">
                    <br />
                    <b>{{ $t('document.incompleteHelp') }}</b>
                  </span>
                </div>
              </td>
              <td v-if="!readOnly" class="d-flex">
                <DocumentDropbox update="modify" :document="doc" :uuid="uuid" @document-uploaded="onDocumentUploaded" />
                <DocumentShowAction class="ml-2" :document="doc" :uuid="uuid" />
                <DocumentDownloadButton class="ml-2" :document="doc" have-btn :uuid="uuid" />
                <ButtonAll
                  class="ml-2"
                  v-if="isAllowedToDeleteDocument(doc)"
                  icon="trash"
                  type="danger"
                  size="small"
                  margin="no"
                  :loading="deleting"
                  :title="$t('document.clickForDel')"
                  @click="deleteDocument(doc)"
                  name="deleteDocument"
                />
                <ButtonAll
                  v-if="isAllowedToSign(doc)"
                  class="ml-2"
                  icon="sign"
                  :type="getStatusSignColor(doc)"
                  size="small"
                  margin="no"
                  @click="prepareDocumentSign(doc)"
                  name="showDocumentSigner"
                />
              </td>
            </tr>
            <tr v-if="isAllowedToSign(doc) && collapse === doc.id" :e2e-row="'isAllowedToSignDocument-' + index">
              <td colspan="3" class="p-0">
                <DocumentSignBlock
                  :document="doc.document"
                  :document-assoc-id="doc.id"
                  :uuid="uuid"
                  variant="documents_view"
                />
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>

    <ModalConfirmation
      id="modalconfirmation"
      ref="modalconfirmation"
      message="document.modal.addSign"
      @confirm="addSign"
      :loader="true"
    />
  </div>
</template>
